module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign"
  }, [_c('div', {
    ref: "head",
    staticClass: "sign_head"
  }, [_c('img', {
    staticClass: "sign_icon",
    attrs: {
      "src": require("../../assets/images/sign/icon-back.png"),
      "alt": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('div', {
    staticClass: "sign_body"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("请横向签名")]), _vm._v(" "), _c('canvas', {
    ref: "canvas"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-258bb924","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/Sign.vue
// module id = 524
// module chunks = 2